import { Box } from "@mui/material";
import { sessionContainer } from "./containerStyles";

const SessionContainer = ({ children }) => {
  return (
    <Box className="session-container" sx={(theme) => sessionContainer(theme)}>
      {children}
    </Box>
  );
};

export default SessionContainer;
